export default {
	home: {
		name: ""
	},
	page_out_trade_no: "Número de pedido del comerciante",
	page_merchant_sub_order_no: "Número de subpedido del comerciante",
	_start_recording: "Iniciar grabación",
	_stop_recording: "Detener grabación",
	_switch_obj: "Cambiar a OBJ",
	_switch_gaussian: "Cambiar a Gaussian",
	_switch_glb: "Cambiar a GLB",
	_model_has_no_obj: "Este modelo no tiene modelo OBJ",
	_model_has_no_gaussian: "Este modelo no tiene modelo Gaussian",
	_model_does_not_exist: "El modelo no existe",
	"_no_photos!": "Sin fotos",
	_image_loading_failed: "Error al cargar la imagen",
	_no_gaussian_model_available: "No hay modelo Gaussian disponible",
	_no_normal_map_available: "No hay mapa normal del modelo disponible",
	"_model_loading_failed,_please_try_again_later":
		"Error al cargar el modelo. Inténtalo de nuevo más tarde",
	"_obj_model_does_not_exist,_automatically_switched_to_gaussian_preview":
		"El modelo OBJ no existe. Se cambió automáticamente a la vista previa Gaussian",
	_original_uploaded_photo: "Foto original subida",
	_effect_image: "Imagen de efecto",
	submit_modeling_model_file_not_ready:
		"El archivo del modelo aún no está listo. Inténtalo de nuevo más tarde o contacta con soporte.",
	finance_package_order_reverse: "Reversión de paquete a precio fijo",
	finance_shop_red_reversal: "Reversión de tienda",
	finance_dealer_red_reversal: "Reversión de distribuidor"
};
